import { Link } from 'react-router-dom';
import { categories, videos } from '@/mocks/videos';

export default function CategoryStrip() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
      {categories.map((cat) => {
        const count = videos.filter((v) => v.categoryId === cat.id).length;
        return (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex flex-col items-center text-center gap-2 rounded-lg border border-background-200/70 bg-background-100 px-3 py-5 hover:border-accent-500 hover:bg-background-200/50 transition-colors"
          >
            <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500/15 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
              <i className={`${cat.icon} text-2xl`} />
            </span>
            <span className="text-sm font-semibold text-foreground-900">{cat.name}</span>
            <span className="text-xs text-foreground-500">{count} 部内容</span>
          </Link>
        );
      })}
    </div>
  );
}